{
  "w": 22,
  "h": 15,
  "rows": [
    "......................",
    "......WWWWWWWWWW......",
    "......BBCCKKCCBB......",
    ".....BBCCCKKCCCBB.....",
    "....BBCCCCKKCCCCBB....",
    "...BBcccccKKcccccBB...",
    "..KBBBBBBBBBBBBBBBBK..",
    "..BBBBBBBBBBBBBBBBBB..",
    ".BBBBBBBBBBBBBBBBBBBB.",
    "BBBBBBBBBBBBBBBBBBBBBB",
    "YYYbbbbbbbbbbbbbbbbYYY",
    "BBKKKKbKKKKKKKKbKKKKBB",
    "KWKKKKKKKKKKKKKKKKKKWK",
    "..KKK............KKK..",
    "......................"
  ],
  "legend": {
    "K": "C.BLACK",
    "B": "C.B_BLUE",
    "b": "C.BLUE",
    "C": "C.B_CYAN",
    "c": "C.CYAN",
    "W": "C.B_WHITE",
    "Y": "C.B_YELLOW"
  }
}
